import React from 'react'
/* eslint-disable react/forbid-prop-types */
import { any } from 'prop-types'
import PermissionRouteWithFallback from './PermissionRouteWithFallback'

export default function AssetPermissionRouteWithFallback({
  component: Component,
  path,
  exact,
  fallback: Fallback,
  children,
  requirePersonalData,
}) {
  return (
    <PermissionRouteWithFallback
      component={Component}
      path={path}
      exact={exact}
      fallback={Fallback}
      requirePersonalData={requirePersonalData}
      permissionName="DiscoveryAssetPermission"
      permissionContext="DiscoveryAdminAssetContext"
    >
      {children}
    </PermissionRouteWithFallback>
  )
}

AssetPermissionRouteWithFallback.propTypes = {
  children: any,
  component: any,
  fallback: any.isRequired,
}
